import { SERVICES } from 'src/config/constants'
import { Loader } from 'src/utils/loader'

class UploadLoader extends Loader {}

export const uploadLoader = new UploadLoader({
  service: SERVICES.upload,
})
